import React, { Component } from "react";

class MediaItem extends Component {
  render() {
    return (
      <div style={mediaWrapperStyle}>
        <div style={mediaIconStyle}>
          <p style={iconDateStyle}>{this.props.media.date}</p>
        </div>
        <div style={mediaStyle}>
          <p style={mediaHeaderStyle}>
            {this.props.media.publication}: {this.props.media.title}
          </p>
          <hr style={hr} />
          <div style={mediaAbstractStyle}>
            <p style={mediaAbstractTextStyle}>{this.props.media.text}</p>
          </div>
          <div style={mediaLinkStyle}>
            <a href={this.props.media.link} target="_blank">
              <p style={mediaLinkTextStyle}>{this.props.media.cta}</p>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const mediaWrapperStyle = {
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  overflow: "auto",
};

const mediaIconStyle = {
  width: "160px",
  margin: "14px 10px 10px 20px",
  borderRadius: "6px",
  textAlign: "right",
};

const iconDateStyle = {
  height: "20px",

  fontFamily: "Titillium Web, sans-serif",
  fontSize: "16px",
  fontStyle: "italic",
  color: "#000",
  margin: "0px 10px 4px 10px",
};

const mediaStyle = {
  maxWidth: "550px",
  backgroundColor: "white",
  margin: "10px 30px 20px 10px",
  borderRadius: "6px",
};

const mediaHeaderStyle = {
  fontFamily: "Titillium Web, sans-serif",
  fontSize: "20px",
  padding: "0 10px 0 10px",
  margin: "10px 20px 10px 20px",
};

const mediaAbstractStyle = {
  maxWidth: "500px",
  margin: "0px auto",
  textAlign: "justify",
  overflowY: "hidden",
  padding: "0px 10px 0px 10px",
};

const mediaAbstractTextStyle = {
  fontFamily: "Titillium Web, sans-serif",
  fontSize: "20px",
  fontStyle: "italic",
  margin: "0 0 1rem 0",
  color: "#555",
};

const mediaLinkStyle = {
  height: "30px",
  margin: "10px auto 10px auto",
  paddingRight: "1rem",
  textAlign: "right",
};

const mediaLinkTextStyle = {
  fontFamily: "Titillium Web, sans-serif",
  fontSize: "20px",
};

const hr = {
  height: "2px",
  width: "80%",
  border: "0",
  borderTop: "1px solid #aaa",
  margin: "12px auto",
  padding: "0",
};

export default MediaItem;
